/**
 * The three voices a focus surface can speak in.
 *
 * `alert` is red and means something is broken — a failed read, a lost sender,
 * a stalled system. `warn` is amber and means the founder has to do something
 * before the product can carry on: top up, approve more contacts. Nothing is
 * wrong in a warn state, which is why it must not be red — red reads as "we
 * broke", and spending it on ordinary asks leaves nothing to say a real fault
 * with.
 */
export type SurfaceTone = 'default' | 'warn' | 'alert'

/** Text colour for a tone — headline accents, eyebrows, labels. */
export const toneText = (tone: SurfaceTone = 'default'): string =>
  tone === 'alert' ? 'text-red-400' : tone === 'warn' ? 'text-amber-400' : 'text-primary'

/** Border colour for a tone — the focus card's own edge. */
export const toneBorder = (tone: SurfaceTone = 'default'): string =>
  tone === 'alert'
    ? 'border-red-400/30'
    : tone === 'warn'
      ? 'border-amber-400/30'
      : 'border-border/40'
